import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const buildium = defineConnector({
  identifier: "buildium",
  name: "Buildium",
  tagLine: "Property management platform",
  logo,
  protocol: "http",
  tags: ["productivity"],
  defaultUrlPattern: () =>
    "https://api\\.buildium\\.com/.*|https://apisandbox\\.buildium\\.com/.*",
  auth: (app) =>
    headerAuth([
      {
        name: "x-buildium-client-id",
        value: app.secret.clientId,
      },
      {
        name: "x-buildium-client-secret",
        value: app.secret.clientSecret,
      },
    ]),
  steps: [
    {
      title: "Create API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "In [Buildium](https://www.buildium.com/), go to **Settings › API** and generate a client ID and client secret. See the [API docs](https://developer.buildium.com/) for details.",
        },
      ],
    },
    {
      title: "Enter your credentials",
      items: [
        {
          kind: "input",
          label: "Client ID",
          required: true,
          target: { kind: "secrets", field: "clientId" },
        },
        {
          kind: "input",
          label: "Client secret",
          required: true,
          target: { kind: "secrets", field: "clientSecret" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.buildium.com/v1/administration/account",
  },
});
